goog.provide("shadow.js.shim.module$$mui$material$Grow$default");
shadow.js.shim.module$$mui$material$Grow$default = shadow.js.shim.module$$mui$material$Grow.default;
